import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 bg-success" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder text-light fs-2 mt-2" }, " Status of Training Activities "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-secondary fw-bold ml-3 mt-2" }, " (Last Update time : 08-01-2022 05:55 pm) ")
  ])
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-5" }
const _hoisted_7 = { class: "table-responsive mt-5" }
const _hoisted_8 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-25px text-center align-middle border border-gray-400",
      rowspan: "2"
    }, " SL "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-250px text-center align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Tranche Name "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-50px text-center align-middle border border-gray-400",
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-140px text-center align-middle border border-gray-400",
      colspan: "2"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400",
      colspan: "2"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400",
      colspan: "3"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary border border-gray-400" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " O/W Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " O/W Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " O/W Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "3"
    }, " % on Certified ")
  ])
], -1)
const _hoisted_10 = { style: {} }
const _hoisted_11 = { class: "border border-gray-400" }
const _hoisted_12 = {
  class: "text-info fw-bolder text-hover-primary",
  colspan: "10"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
  /*#__PURE__*/_createElementVNode("td", null, "1"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "/course-summary/1" }, " Tranche 1")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7565 "),
  /*#__PURE__*/_createElementVNode("td", null, "7328"),
  /*#__PURE__*/_createElementVNode("td", null, "298"),
  /*#__PURE__*/_createElementVNode("td", null, "6164"),
  /*#__PURE__*/_createElementVNode("td", null, "4786"),
  /*#__PURE__*/_createElementVNode("td", null, "4523"),
  /*#__PURE__*/_createElementVNode("td", null, "452"),
  /*#__PURE__*/_createElementVNode("td", null, "42")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
  /*#__PURE__*/_createElementVNode("td", null, "2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " Additional Tranche 1 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7565 "),
  /*#__PURE__*/_createElementVNode("td", null, "7328"),
  /*#__PURE__*/_createElementVNode("td", null, "298"),
  /*#__PURE__*/_createElementVNode("td", null, "6164"),
  /*#__PURE__*/_createElementVNode("td", null, "4786"),
  /*#__PURE__*/_createElementVNode("td", null, "4523"),
  /*#__PURE__*/_createElementVNode("td", null, "452"),
  /*#__PURE__*/_createElementVNode("td", null, "42")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
  /*#__PURE__*/_createElementVNode("td", null, "3"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " Tranche 2 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7565 "),
  /*#__PURE__*/_createElementVNode("td", null, "7328"),
  /*#__PURE__*/_createElementVNode("td", null, "298"),
  /*#__PURE__*/_createElementVNode("td", null, "6164"),
  /*#__PURE__*/_createElementVNode("td", null, "4786"),
  /*#__PURE__*/_createElementVNode("td", null, "4523"),
  /*#__PURE__*/_createElementVNode("td", null, "452"),
  /*#__PURE__*/_createElementVNode("td", null, "42")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
  /*#__PURE__*/_createElementVNode("td", null, "4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " Additional Tranche 2 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7565 "),
  /*#__PURE__*/_createElementVNode("td", null, "7328"),
  /*#__PURE__*/_createElementVNode("td", null, "298"),
  /*#__PURE__*/_createElementVNode("td", null, "6164"),
  /*#__PURE__*/_createElementVNode("td", null, "4786"),
  /*#__PURE__*/_createElementVNode("td", null, "4523"),
  /*#__PURE__*/_createElementVNode("td", null, "452"),
  /*#__PURE__*/_createElementVNode("td", null, "42")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
  /*#__PURE__*/_createElementVNode("td", null, "5"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " Tranche 3 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7565 "),
  /*#__PURE__*/_createElementVNode("td", null, "7328"),
  /*#__PURE__*/_createElementVNode("td", null, "298"),
  /*#__PURE__*/_createElementVNode("td", null, "6164"),
  /*#__PURE__*/_createElementVNode("td", null, "4786"),
  /*#__PURE__*/_createElementVNode("td", null, "4523"),
  /*#__PURE__*/_createElementVNode("td", null, "452"),
  /*#__PURE__*/_createElementVNode("td", null, "42")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "text-dark fw-bolder text-hover-primary fs-6"
  }, " Total "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7565 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 7328 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, "298"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 6164 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 4786 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " 4523 "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, "452"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, "42")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (data, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("tr", _hoisted_11, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(data.entity_name), 1)
                ]),
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _hoisted_17,
                _hoisted_18
              ], 64))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}